<template>
    <div>
        <div class="fix-icon" @click="$router.push({name:'Home',params:{keepAlive:'false'}})">
            <img src="../assets/menu/gengduomeiw.png">
        </div>
    </div>

</template>

<script>
    export default {
        name: "goHome",
        data() {
            return {};
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    .fix-icon{
        position: fixed;
        right: 0;
        bottom: 150px;
        img{
            width: 172px;
        }
    }

</style>